<script lang="ts">
    import HomeIcon from "@app/components/Icons/HomeIcon.svelte";
    import MyFavoriteTranslationsForDict from "./MyFavoriteTranslationsForDict.svelte";
    import MyFavoriteTranslationsIndex from "./MyFavoriteTranslationsIndex.svelte";
    import Breadcrumbs from "@app/components/Breadcrumbs/Breadcrumbs.svelte";

    const urlParams = new URLSearchParams(window.location.search);
    const l1 = urlParams.get("l1");
    const l2 = urlParams.get("l2");



</script>

<div class="m-auto text-xs text-slate-600 py-2 max-w-76 px-2">
    <Breadcrumbs />
</div>
{#if l1 && l2}
    <MyFavoriteTranslationsForDict {l1} {l2} />
{:else}
    <MyFavoriteTranslationsIndex />
{/if}
